import Vue from 'vue'
import router from '@/router'
import store from '@/store'

let cancelView = null
let srcView = null
let cancelReport = null
let srcReport = null

const reqReportsList = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.analytics.all}`, payload)
}
const reqReport = payload => {
  cancelView = axios.CancelToken
  srcReport = cancelView.source()

  return axios.get(
    `${Vue.config.server}/${Vue.config.modules.crm.api.analytics.one.replace('$1', payload.id)}`,
    payload,
  )
}
const reqReportCreate = payload => {
  return axios.post(`${Vue.config.server}/${Vue.config.modules.crm.api.analytics.all}`, payload.params)
}
const reqReportUpdate = payload => {
  return axios.put(
    `${Vue.config.server}/${Vue.config.modules.crm.api.analytics.one.replace('$1', payload.id)}`,
    payload.params,
  )
}
const reqReportDelete = payload => {
  return axios.delete(`${Vue.config.server}/${Vue.config.modules.crm.api.analytics.one.replace('$1', payload.id)}`)
}
const reqReportData = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.analytics.data}`, payload)
}
const reqReportView = payload => {
  cancelReport = axios.CancelToken
  srcView = cancelReport.source()

  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.analytics.view}`, {
    cancelToken: srcView.token,
    params: payload.params,
  })
}
const reqDetailsSearch = payload => {
  return axios.get(
    `${Vue.config.server}/${Vue.config.modules.crm.api.analytics.detail.replace('$1', payload.id)}`,
    payload,
  )
}
const reqFilterList = payload => {
  return axios.get(
    `${Vue.config.server}/${Vue.config.modules.crm.api.analytics.filter.replace('$1', payload.id)}`,
    payload,
  )
}

const reqFillStudios = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.analytics.fillStudios}`, payload)
}

export default {
  GET_REPORTS_LIST: ({ commit, state }, payload) => {
    return reqReportsList(payload)
      .then(response => {
        const data = response.data.data
        commit('setAnalyticsList', data.items)
        commit('setAnalyticsFilters', data.filters)
        return data.count
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.loadingError,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },
  GET_REPORT: ({ commit, state }, payload) => {
    if (srcView) {
      srcView.cancel()
    }
    if (srcReport) {
      srcReport.cancel()
    }

    return reqReport(payload)
      .then(response => {
        const data = response.data.data
        const details = response.data.details
        const filters = response.data.filters
        const view = response.data.view
        commit('setAnalyticsReport', data)
        commit('setDetailsList', details)
        commit('setFiltersList', filters)
        commit('setAnalyticsFormatName', view.group)
        commit('setAnalyticsDataGraph', view)
        commit('setAnalyticsDataView', view.list)
        commit('setAnalyticsDataSum', view.sum)
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          throw 'Canceled'
        }

        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.loadingError,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },
  CREATE_REPORT: ({ commit, state }) => {
    return reqReportCreate({
      params: {
        title: state.analyticsReport.title,
        settings: state.analyticsReport.settings,
      },
    })
      .then(response => {
        const data = response.data.data
        commit('setAnalyticsReport', data)

        router.push({ path: Vue.config.modules.crm.route.analytics.one.replace('$1', state.analyticsReport.id) })

        Vue.notify({
          group: 'hasBottomNavigation',
          title: '',
          type: 'success',
          text: Vue.config.localization.ru.savedMessage,
        })
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: 'Ошибка обновления',
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },
  UPDATE_REPORT: ({ commit, state }) => {
    return reqReportUpdate({
      id: state.analyticsReport.id,
      params: {
        employer_id: store.getters.user.id,
        title: state.analyticsReport.title,
        settings: state.analyticsReport.settings,
      },
    })
      .then(response => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: '',
          type: 'success',
          text: Vue.config.localization.ru.savedMessage,
        })
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: 'Ошибка обновления',
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },
  DELETE_REPORT: ({ commit, state }) => {
    return reqReportDelete({
      id: state.analyticsReport.id,
    })
      .then(response => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: '',
          type: 'success',
          text: Vue.config.localization.ru.deleteMessage,
        })

        router.push({ path: Vue.config.modules.crm.route.analytics.all })
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: 'Ошибка удаления',
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },
  GET_REPORT_DATA: ({ commit, state }, payload) => {
    return reqReportData(payload)
      .then(response => {
        const data = response.data.data
        commit('setAnalyticsData', data)
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.loadingError,
          type: 'error',
          text: error.response?.data?.message ?? '',
        })
      })
  },
  RETURN_REPORT_VIEW: ({ commit, state }, payload) => {},
  GET_REPORT_VIEW: ({ commit, state }, payload) => {
    if (srcView) {
      srcView.cancel()
    }

    return reqReportView(payload)
      .then(response => {
        const data = response.data.data
        commit('setAnalyticsFormatName', data.group)
        commit('setAnalyticsDataGraph', data)
        commit('setAnalyticsDataView', data.list)
        commit('setAnalyticsDataSum', data.sum)
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          throw 'Canceled'
        }

        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.loadingError,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },
  GET_REPORT_VIEW_SCROLLABLE: ({ commit, state }, payload) => {
    if (srcView) {
      srcView.cancel()
    }

    return reqReportView(payload)
      .then(response => {
        const data = response.data.data

        const showPhone = Vue.prototype.$checkPermission('App\\Models\\User.show_phone')

        if (!showPhone) {
          data.list.forEach(element => {
            element.sph = element.sph !== null && element.sph !== undefined ? element.sph.slice(-4) : ''
          })
        }

        if (payload.params.offset === 0) {
          commit('setAnalyticsFormatName', data.group)
          commit('setAnalyticsDataGraph', data)
          commit('setAnalyticsDataView', data.list)
          commit('setAnalyticsDataSum', data.sum)
          commit('setReportInfo', data.info)
        } else {
          commit('updateAnalyticsDataView', data.list)
        }
      }, payload)
      .catch(err => {
        const errors = err.response.data
        for (let error in errors) {
          Vue.notify({
            group: 'hasBottomNavigation',
            title: Vue.config.localization.ru.loadingError,
            type: 'error',
            text: errors[error].join('<br>'),
          })
        }
      })
  },
  GET_DETAILS_LIST: ({ commit, state }, payload) => {
    return reqDetailsSearch(payload)
      .then(response => {
        const data = response.data.data
        commit('setDetailsList', data)
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.loadingError,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },
  INIT_REPORT: ({ commit, state }, payload) => {
    return axios
      .all([reqReportData(payload), reqReport(payload)])
      .then(
        axios.spread((resReportData, resReport) => {
          const datReportData = resReportData.data.data
          commit('setAnalyticsData', datReportData)

          const datReport = resReport.data.data
          const datDetails = resReport.data.details
          const datFilters = resReport.data.filters
          const datView = resReport.data.view
          commit('setAnalyticsReport', datReport)
          commit('setDetailsList', datDetails)
          commit('setFiltersList', datFilters)
          commit('setAnalyticsFormatName', datView.group)
          commit('setAnalyticsDataGraph', datView)
          commit('setAnalyticsDataView', datView.list)
          commit('setAnalyticsDataSum', datView.sum)
        }),
      )
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.loadingError,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },
  GET_FILTER_LIST: ({ commit, state }, payload) => {
    return reqFilterList(payload)
      .then(response => {
        const data = response.data.data
        commit('setFiltersList', data)
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.loadingError,
          type: 'error',
          text: error.response ? `${error.response.status} ${error.response.statusText}` : '',
        })
      })
  },
  GET_FILL_STUDIOS: ({ commit, state }, payload) => {
    return reqFillStudios(payload)
      .then(response => {
        const data = response.data.data
        commit('setAnalyticsFillStudios', data)
      })
      .catch(error => {
        Vue.notify({
          group: 'hasBottomNavigation',
          title: Vue.config.localization.ru.loadingError,
          type: 'error',
          text: error.response?.data?.message ?? '',
        })
      })
  },
}
